import { Controller, useFormContext } from 'react-hook-form';

import ReactSelect from 'dashboard/components/ReactSelect';
import { EditorableSchema } from 'dashboard/components-lib/FieldSchemaEditor/constants';
import { InputLabel } from 'dashboard/components-lib/FieldSchemaEditorForm/shared';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { FieldSchemaType } from 'lib/fields';

interface MaxCharLengthControls {
  fieldSchema: EditorableSchema;
  fieldName: string;
  formContext: ReturnType<typeof useFormContext>;
  canEdit: (fieldSchema: EditorableSchema) => boolean;
}

export const StringFieldControls: React.FC<MaxCharLengthControls> = ({
  fieldSchema,
  fieldName,
  formContext,
  canEdit,
}) => {
  const { control } = formContext;

  if (fieldSchema.type !== FieldSchemaType.String) {
    return <></>;
  }

  return (
    <>
      <Spacer height={2} />
      <InputLabel htmlFor='field-schema-panel__field-string-max-length'>
        Max length (char)
      </InputLabel>
      <Controller
        name={`${fieldName}.config.max-char-length`}
        control={control}
        render={({ field: { value, onChange } }) => (
          <Input
            id='field-schema-panel__field-string-max-length'
            aria-label='Max Length'
            value={value}
            type='number'
            disabled={!canEdit(fieldSchema)}
            onChange={(e) => onChange(parseInt(e.target.value))}
          />
        )}
      />
      <Spacer height={2} />
      <InputLabel htmlFor='field-schema-panel__field-sanitize'>String sanitization</InputLabel>
      <Controller
        name={`${fieldName}.config.sanitize`}
        control={control}
        render={({ field: { value, onChange } }) => (
          <ReactSelect
            id='field-schema-panel__field-sanitize'
            aria-label='String sanitization'
            value={value}
            options={[{ label: 'HTML', value: 'html' }]}
            onChange={onChange}
            disabled={!canEdit(fieldSchema)}
            isMulti
          />
        )}
      />
    </>
  );
};
